export interface IStorage {
  category: {
    files: number;
    liveStream: number;
    other: number;
    vod: {
      filmFestival: number;
      general: number;
    };
  };
  limit: number;
  used: number;
}

export interface IManualBilling {
  agreementType: "FIXED_TERM" | "MONTHLY_RATE";
  agreedAmount: number;
  amountPaid: number;
  currency: string;
  paymentMethod: string;
  latestPaymentId: string;
  accessStartsAt: string;
  accessEndsAt: string;
  graceEndsAt: string;
  stripeInvoiceId: string;
  stripeTransition?: {
    timing: "AT_PERIOD_END" | "IMMEDIATE";
    subscriptionId: string;
    effectiveAt: string;
    status: string;
  } | null;
}

export interface IPendingManualBilling {
  packageId: string;
  packageName: string;
  effectiveAt: string;
  manualBilling: IManualBilling;
}

export interface IUser {
  userId: string;
  email: string;
  name: string;
  phone: string;
  storage: IStorage;
  isAdmin: boolean;
  isConfirmed?: boolean;
  subscriptionInfo?: {
    customerId?: string;
    status: string;
    subscriptionId?: string;
    packageId: string;
    billingMode?: "STRIPE" | "MANUAL";
    paymentStatus?: "PAID" | "PENDING" | "PAYMENT_FAILED" | "ACTION_REQUIRED";
    stripeStatus?: string;
    paymentFailureCode?: string;
    paymentCheckedAt?: string;
    pendingPackageId?: string;
    cancelAtPeriodEnd?: boolean;
    cancelAt?: number;
    manualBilling?: IManualBilling;
    pendingManualBilling?: IPendingManualBilling;
  };
  manualpayInfo?: {
    description: string;
    paydate: string;
    validitydate: string;
    amount: number;
    accno: string;
  };
}

export interface IUserRequest {
  userId: string;
  email: string;
  name: string;
  phoneNumber: string;
  isConfirmed?: boolean;
}

export enum RegistrationStatus {
  ACCOUNT_INFO = "ACCOUNT_INFO",
  BILLING_INFO = "BILLING_INFO",
  PAYMENT_INFO = "PAYMENT_INFO",
}
